@if (locationState()?.isLoading) {
  <app-edit-form-skeleton />
  <ui-skeleton class="block h-8 w-[174px] rounded-md mt-6" />
} @else if (locationState()?.data) {
  @if (locationState()?.data; as location) {
    <app-location-details-edit-form
      [location]="location"
      [locationId]="locationId()"
      [organizationId]="organizationId()"
    />
    <div class="mt-6">
      <ui-button
        mode="outlined"
        size="small"
        type="button"
        (click)="onClickDelete()"
        [loading]="isDeleteLoading()"
      >
        <div slot="start" class="text-error dark:text-error-darkmode">
          <ng-icon name="heroTrash" size="20" class="!block" />
        </div>
        <div class="text-error dark:text-error-darkmode">
          {{ 'cockpit.locations.details.general.deleteButton' | transloco }}
        </div>
      </ui-button>
    </div>
  }
}
